import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { ChangeEditionPageRestrictionsLegacyCoordinator } from '../PageRestrictionsLegacyCoordinator/ChangeEditionPageRestrictionsLegacyCoordinator.js';
import { ChangeEditionSectionMessageLegacyCoordinator } from '../SectionMessageLegacyCoordinator/ChangeEditionSectionMessageLegacyCoordinator.js';

/**
 * @deprecated Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */
export const ChangeEditionLegacyCoordinator = () =>
	useSessionData().edition === 'FREE' ? (
		<>
			<TransparentErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
				<ChangeEditionSectionMessageLegacyCoordinator />
			</TransparentErrorBoundary>
			<TransparentErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
				<ChangeEditionPageRestrictionsLegacyCoordinator />
			</TransparentErrorBoundary>
		</>
	) : null;
